<div class="module-config-dialog">
    <!-- Toast for Weight Validation -->
    <p-toast key="weightValidation" position="top-right" [baseZIndex]="10000"></p-toast>
    
    <div class="dialog-header">
        <span>Configure &gt; {{ moduleName }}</span>
        <button class="close-btn" (click)="close()">
            <span class="material-icons">close</span>
        </button>
    </div>
    <div class="dialog-content" style="display: flex; flex-direction: column; align-items: flex-start;">
        <ng-container *ngIf="!hideHeaderFields">
            <mat-form-field appearance="fill" class="dialog-input">
                <mat-label>Module Alias Name</mat-label>
                <input #aliasInput matInput [(ngModel)]="aliasName" name="aliasName" required />
                <mat-error *ngIf="aliasInput.invalid && aliasInput.touched">
                    Alias Name is required
                </mat-error>
            </mat-form-field>
            <mat-form-field appearance="fill" class="dialog-input">
                <mat-label>Module Type</mat-label>
                <mat-select [(ngModel)]="moduleType" name="moduleType" #moduleTypeModel="ngModel" required>
                    <mat-option *ngFor="let type of filteredModuleTypes" [value]="type.type_name">
                        {{ type.type_name.trim() }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="moduleTypeModel.invalid && moduleTypeModel.touched">
                    Module Type is required
                </mat-error>
            </mat-form-field>
        </ng-container>
        <!-- Position No dropdown - above Display on Dashboard checkbox -->
        <mat-form-field appearance="fill" class="dialog-input" *ngIf="configuredGridModulesCount > 0">
            <mat-label>Position No</mat-label>
            <mat-select [(ngModel)]="positionNo" name="positionNo">
                <mat-option [value]="null">Select Position</mat-option>
                <mat-option *ngFor="let position of getPositionOptions()" [value]="position">
                    {{ position }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <!-- Display on Dashboard checkbox - always visible for both grid modules and special modules -->
        <mat-checkbox [(ngModel)]="displayOnDashboard" style="margin-bottom: 16px; margin-top: 2px;">Display on Dashboard</mat-checkbox>
        <!-- Add the table here -->
        <div class="p-table-wrapper">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px;">
                <h3 style="margin: 0; font-weight: 600; color: #1976d2; letter-spacing: 0.5px; font-size: 18px;">
                    Configure Parameter <span style="color: red; font-weight: normal;">*</span>
                </h3>
                <div
                    style="display: flex; align-items: center; gap: 12px; flex-direction: column; align-items: flex-end;">
                    <div style="display: flex; align-items: center; gap: 12px;">
                        <div style="position: relative; width: 220px;">
                            <span class="material-icons search-icon">
                                search
                            </span>
                            <input #globalFilter pInputText type="text" [(ngModel)]="globalSearchValue"
                                (input)="onGlobalSearch(globalFilter.value)" placeholder="Search All..." maxlength="50"
                                class="beauty-search-input" (focus)="searchInputFocused = true"
                                (blur)="searchInputFocused = false" />
                        </div>
                        <button mat-flat-button color="primary" style="background: #06152B; color: #fff;"
                            (click)="openAddParameterDialog()">
                            <span class="material-icons" style="vertical-align: middle; margin-right: 4px;">add</span>
                            ADD Parameter
                        </button>
                    </div>
                    <div *ngIf="searchError"
                        style="color: #e53935; font-size: 8px; margin-top: 2px; align-self: flex-start;">
                        {{ searchError }}
                    </div>
                </div>
            </div>
            <div style="margin-bottom: 12px; padding: 8px 12px; background: #e3f2fd; border-radius: 6px; border-left: 4px solid #1976d2;">
                <p style="margin: 0; font-size: 13px; color: #1565c0;">
                    <span class="material-icons" style="font-size: 16px; vertical-align: middle; margin-right: 4px;">info</span>
                    <strong>Range Management:</strong> Click the edit button to add/remove ranges. New ranges are created with empty min/max values - you can fill them in manually according to your requirements. Each range should have min < max values.
                </p>
            </div>
            <p-table #dt [value]="products" [(selection)]="selectedProducts" [dataKey]="'code'" [style]="{ width: '100%' }"
                [tableStyle]="{ width: '100%' }" responsiveLayout="scroll"
                [globalFilterFields]="['parameters', 'type', 'code', 'calculation']" [filterDelay]="0"
                [scrollable]="true" scrollHeight="400px">
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 3rem"></th>
                        <th style="text-align: center;">
                            <div>Parameters</div>
                            <input type="text" [(ngModel)]="parameterPrefix"
                                (ngModelChange)="onParameterPrefixChange($event)"
                                placeholder="Prefix" maxlength="50"
                                title="Text entered here is added as a prefix to every parameter name"
                                style="width: 100px; margin-top: 4px; padding: 2px 6px; border-radius: 4px; border: 1px solid #ccc; font-weight: normal; color: #333;" />
                        </th>
                        <th style="text-align: center;">Unit</th>
                        <th style="text-align: center;">
                            Type
                        </th>
                        <th style="width: 50px;">
                            Code
                        </th>
                        <th style="width: 80px; text-align: center;">Upload Type</th>
                        <th style="text-align: center;">Weight</th>
                        <th style="text-align: center;">Formula</th>
                        <th style="text-align: center;">Calculation</th>
                        <th style="text-align: center;">Range</th>
                        <th style="text-align: center;">Score</th>
                        <th style="text-align: center;">Min</th>
                        <th style="text-align: center;">Max</th>
                        <th style="text-align: center;">Query</th>
                        <th style="text-align: center;">Critical Parameter</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                    <tr *ngFor="let range of product.ranges; let i = index" [ngClass]="{
                'product-selected': selectedProducts?.includes(product),
                'range-selected': range.selected,
                'range-validation-error': range.hasValidationError && range.selected
            }">
                        <ng-container *ngIf="i === 0">
                            <td [attr.rowspan]="product.ranges.length"
                                style="vertical-align: middle; text-align: center;">
                                                                    <div
                                        style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                                        <input type="checkbox" [checked]="selectedProducts?.includes(product)"
                                            (change)="toggleProductSelection(product)"
                                            style="width: 22px; height: 22px; accent-color: #1976d2; cursor: pointer;" />
                                        <!-- Debug info: show product selection state -->
                                        
                                        <ng-container *ngIf="editingProduct !== product">
                                            <span class="material-icons"
                                                style="cursor:pointer; color:#1976d2; font-size:22px; margin-top:8px;"
                                                [style.cursor]="selectedProducts?.includes(product) ? 'pointer' : 'not-allowed'"
                                                [style.color]="selectedProducts?.includes(product) ? '#1976d2' : '#ccc'"
                                                (click)="selectedProducts?.includes(product) ? startEdit(product) : null"
                                                [title]="selectedProducts?.includes(product) ? 'Edit' : 'Select checkbox first to edit'">
                                                edit
                                            </span>
                                        </ng-container>
                                    <ng-container *ngIf="editingProduct === product">
                                        <div style="display: flex; align-items: center; gap: 8px; margin-top: 8px;">
                                            <button mat-flat-button color="primary" style="min-width: 60px;"
                                                (click)="saveEdit(product)" [disabled]="!hasProductChanged(product) || isParameterExceedingLimit(product)">
                                                Save
                                            </button>
                                            <button mat-icon-button color="warn" (click)="cancelEdit(product)" title="Cancel edit">
                                                <mat-icon>close</mat-icon>
                                            </button>
                                        </div>
                                        <span style="margin-top: 8px; font-size: 12px; color: #666; font-weight: 500;">
                                            ({{ product.ranges.length }} ranges)
                                        </span>
                                    </ng-container>
                                </div>
                            </td>
                            <td [attr.rowspan]="product.ranges.length">
                                <ng-container *ngIf="editingProduct === product; else parametersView">
                                    <div style="display: flex; flex-direction: column;">
                                        <input [(ngModel)]="product.parameters" 
                                            style="width: 100px;"
                                            [style.border-color]="product.parameters?.length > 100 ? '#f44336' : ''"
                                            [style.box-shadow]="product.parameters?.length > 100 ? '0 0 0 2px rgba(244, 67, 54, 0.2)' : ''" />
                                        <span *ngIf="product.parameters?.length > 100" 
                                            style="color: #f44336; font-size: 10px; margin-top: 2px;">
                                            Character limit exceeded ({{product.parameters?.length}}/100)
                                        </span>
                                    </div>
                                </ng-container>
                                <ng-template #parametersView>
                                    <span style="text-align: center;">{{product.parameters}}</span>
                                </ng-template>
                            </td>
                            <td [attr.rowspan]="product.ranges.length">
                                <ng-container *ngIf="editingProduct === product; else unitView">
                                    <input [(ngModel)]="product.unit" style="width: 60px;" />
                                </ng-container>
                                <ng-template #unitView>
                                    <span style="text-align: center;">{{product.unit}}</span>
                                </ng-template>
                            </td>
                            <td [attr.rowspan]="product.ranges.length">
                                <ng-container *ngIf="editingProduct === product; else typeView">
                                    <select [ngModel]="product.type" 
                                            (ngModelChange)="onTypeChangeFromEvent(product, $event)"
                                            style="width: 90px; padding: 2px 6px; border-radius: 4px;">
                                        <option *ngFor="let option of getTypeOptions()" [ngValue]="option.value">{{ option.label }}</option>
                                    </select>
                                </ng-container>
                                <ng-template #typeView>
                                    <span style="text-align: center;">{{getTypeLabel(product.type)}}</span>
                                </ng-template>
                            </td>
                            <td [attr.rowspan]="product.ranges.length" style="width: 50px;">
                                <ng-container *ngIf="editingProduct === product; else codeView">
                                    <input [(ngModel)]="product.code" 
                                           (ngModelChange)="onCodeChange(product)"
                                           style="width: 45px;"
                                           readonly />
                                </ng-container>
                                <ng-template #codeView>
                                    <span style="display: inline-block; width: 45px; text-align: center;">{{product.code}}</span>
                                </ng-template>
                            </td>
                            <td [attr.rowspan]="product.ranges.length" style="width: 80px;">
                                <ng-container *ngIf="editingProduct === product; else uploadTypeView">
                                    <select [(ngModel)]="product.uploadType"
                                        style="width: 80px; padding: 2px 6px; border-radius: 4px;">
                                        <option value="" disabled selected style="color: black;">Select</option>
                                        <option *ngFor="let type of uploadTypes" [value]="type">{{ type }}</option>
                                    </select>
                                </ng-container>
                                <ng-template #uploadTypeView>
                                    <span style="display: inline-block; width: 80px; text-align: center;">{{product.uploadType || '-'}}</span>
                                </ng-template>
                            </td>
                            <td [attr.rowspan]="product.ranges.length">
                                <ng-container *ngIf="editingProduct === product; else weightView">
                                    <input type="number" [(ngModel)]="product.weight" min="0" style="width: 60px;" 
                                           (input)="onWeightChange(product)" />
                                </ng-container>
                                <ng-template #weightView>
                                    <span style="display: inline-block; width: 60px; text-align: center;">{{product.weight}}</span>
                                </ng-template>
                            </td>
                            <td [attr.rowspan]="product.ranges.length"
                                style="vertical-align: middle; text-align: center;">
                                <ng-container *ngIf="editingProduct === product; else formulaView">
                                    <input [(ngModel)]="product.formula" 
                                           [disabled]="isRawOrDelta(product.type)"
                                           style="width: 100px; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;"
                                           [title]="product.formula" />
                                </ng-container>
                                <ng-template #formulaView>
                                    <span style="display: inline-block; width: 100px; text-align: center; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;" 
                                          [title]="product.formula">{{product.formula?.length > 12 ? product.formula.substring(0, 12) + '...' : product.formula}}</span>
                                </ng-template>
                                <img src="../../../assets/images/icons8-formula-fx-50.png" alt="Edit formula"
                                    style="width: 24px; height: 24px; cursor: pointer; margin-left: 8px; vertical-align: middle;"
                                    [style.cursor]="selectedProducts?.includes(product) && !isRawOrDelta(product.type) ? 'pointer' : 'not-allowed'"
                                    [style.opacity]="selectedProducts?.includes(product) && !isRawOrDelta(product.type) ? 1 : 0.4"
                                    (click)="selectedProducts?.includes(product) && !isRawOrDelta(product.type) ? openFormulaEditor(product) : null"
                                    [title]="isRawOrDelta(product.type) ? 'Formula is not editable for raw/delta types' : (selectedProducts?.includes(product) ? 'Edit formula' : 'Select checkbox first to edit formula')" />
                            </td>
                            <td [attr.rowspan]="product.ranges.length" style="vertical-align: middle; text-align: center;">
                                <div style="display: inline-flex; flex-direction: column; align-items: flex-start; gap: 4px;">
                                    <label style="display: flex; align-items: center; gap: 4px; cursor: pointer; line-height: 1;">
                                        <input type="checkbox"
                                            [checked]="product.calculation === 'DMS'"
                                            [disabled]="editingProduct !== product"
                                            (change)="toggleCalculationSelection(product, 'DMS')" />
                                        <span>DMS</span>
                                    </label>
                                    <label style="display: flex; align-items: center; gap: 4px; cursor: pointer; line-height: 1;">
                                        <input type="checkbox"
                                            [checked]="product.calculation === 'PUREBI'"
                                            [disabled]="editingProduct !== product"
                                            (change)="toggleCalculationSelection(product, 'PUREBI')" />
                                        <span>PUREBI</span>
                                    </label>
                                </div>
                            </td>
                        </ng-container>
                        <!-- Range selection checkbox -->
                        <td>
                            <div class="range-controls">
                                <input type="checkbox" [checked]="range.selected" (change)="onRangeSelect(product, i)"
                                    [disabled]="!selectedProducts?.includes(product) || (range.loadedFromSavedConfig && range.selected && editingProduct !== product)" />
                                <span class="range-number">Range {{i + 1}}</span>
                                <!-- Debug info: show range selection state -->
                                <!-- <span style="font-size: 10px; color: #666; margin-left: 5px;">
                                    ({{range.selected ? 'checked' : 'unchecked'}})
                                </span> -->
                                <!-- Additional debug info -->
                                <!-- <span style="font-size: 8px; color: #999; margin-left: 2px;">
                                    [{{range.loadedFromSavedConfig ? 'saved' : 'new'}}]
                                </span> -->
                                <ng-container *ngIf="editingProduct === product && product.ranges.length > 1">
                                    <button mat-icon-button class="remove-range-btn"
                                        (click)="removeRange(product, i)" title="Remove Range">
                                        <span class="material-icons">delete</span>
                                    </button>
                                </ng-container>
                                <ng-container *ngIf="editingProduct === product && i === product.ranges.length - 1">
                                    <button mat-icon-button class="add-range-btn-small"
                                        (click)="addNewRange(product)" title="Add Range">
                                        <span class="material-icons">add</span>
                                    </button>
                                </ng-container>
                            </div>
                        </td>
                        <td>
                            <input type="number" min="0" max="100" [(ngModel)]="range.score"
                                style="width:60px; text-align:center;" [disabled]="!range.selected" />
                        </td>
                        <td>
                            <input type="number" [(ngModel)]="range.min" style="width:60px; text-align:center;"
                                [disabled]="!range.selected" (input)="onRangeValueChange(product, i, 'min')" 
                                [style.backgroundColor]="range.hasValidationError && range.selected ? '#ffebee' : ''"
                                [style.borderColor]="range.hasValidationError && range.selected ? '#f44336' : ''"
                                [style.borderWidth]="range.hasValidationError && range.selected ? '2px' : '1px'" />
                        </td>
                        <td>
                            <input type="number" [(ngModel)]="range.max" style="width:60px; text-align:center;"
                                [disabled]="!range.selected" (input)="onRangeValueChange(product, i, 'max')" 
                                [style.backgroundColor]="range.hasValidationError && range.selected ? '#ffebee' : ''"
                                [style.borderColor]="range.hasValidationError && range.selected ? '#f44336' : ''"
                                [style.borderWidth]="range.hasValidationError && range.selected ? '2px' : '1px'" />
                        </td>
                        <td style="text-align: center;">
                            <span class="material-icons" style="cursor: pointer; color: #1976d2; font-size: 20px;"
                                (click)="range.selected && openEditor(range)" [title]="range.query || 'Edit query'"
                                [style.opacity]="range.selected ? 1 : 0.4">
                                edit_note
                            </span>
                        </td>
                        <ng-container *ngIf="i === 0">
                            <td [attr.rowspan]="product.ranges.length"
                                style="vertical-align: middle; text-align: center;">
                                <ng-container *ngIf="editingProduct === product; else criticalView">
                                    <mat-checkbox [(ngModel)]="product.criticalParameter" color="warn"></mat-checkbox>
                                </ng-container>
                                <ng-template #criticalView>
                                    <mat-checkbox [(ngModel)]="product.criticalParameter" color="warn"
                                        disabled></mat-checkbox>
                                </ng-template>
                            </td>
                        </ng-container>
                    </tr>
                </ng-template>
            </p-table>
            
            <!-- Debug info: Show when no products -->
            <div *ngIf="!products || products.length === 0" style="padding: 20px; text-align: center; color: #666; background: #f5f5f5; border-radius: 6px; margin-top: 10px;">
                <p><strong>Debug Info:</strong> No products found in the table.</p>
                <p>Products array length: {{products?.length || 0}}</p>
                <p>Module allparameters length: {{module?.allparameters?.length || 0}}</p>
                <p>Module parameters length: {{module?.parameters?.length || 0}}</p>
            </div>
        </div>
        
    </div><br><br>
    <div class="dialog-actions">
        <button mat-stroked-button color="primary" (click)="close()">Cancel</button>
        <button mat-flat-button color="accent" (click)="save()" [disabled]="!isFormValid()">
            Save
        </button>
    </div>
    
    <!-- Header Fields Validation Message -->
    <div *ngIf="!hideHeaderFields && getHeaderFieldsValidationMessage()" 
         class="header-validation-message">
        <span class="material-icons validation-icon">error</span>
        <span class="validation-text">{{ getHeaderFieldsValidationMessage() }}</span>
    </div>
</div>

<div *ngIf="editorVisible" class="custom-editor-modal">
    <div class="custom-editor-backdrop" (click)="editorVisible = false"></div>
    <div class="custom-editor-content">
        <h3>Edit Query</h3>
        <textarea [(ngModel)]="editorText"
            [style]="{ width: '100%', height: '220px', fontSize: '15px', padding: '10px', borderRadius: '6px', border: '1px solid #ccc' }"
            placeholder="Enter query here..."></textarea>
        <div style="text-align:right; margin-top:16px;">
            <button mat-stroked-button color="primary" (click)="editorVisible = false" style="margin-right: 12px;">
                Cancel
            </button>
            <button mat-flat-button color="accent" (click)="saveEditor()">
                Save
            </button>
        </div>
    </div>
</div>

<div *ngIf="formulaEditorVisible" class="custom-editor-modal">
    <div class="custom-editor-backdrop" (click)="formulaEditorVisible = false"></div>
    <div class="custom-editor-content">
        <h3>Edit Formula</h3>
        <textarea [(ngModel)]="formulaEditorText"
            [style]="{ width: '100%', height: '120px', fontSize: '15px', padding: '10px', borderRadius: '6px', border: '1px solid #ccc' }"
            placeholder="Enter formula here..."></textarea>
        <div style="text-align:right; margin-top:16px;">
            <button mat-stroked-button color="primary" (click)="formulaEditorVisible = false"
                style="margin-right: 12px;">
                Cancel
            </button>
            <button mat-flat-button color="accent" (click)="saveFormulaEditor()">
                Save
            </button>
        </div>
    </div>
</div>

<div *ngIf="addParameterDialogVisible" class="custom-editor-modal">
    <div class="custom-editor-backdrop" (click)="closeAddParameterDialog()"></div>
    <div class="custom-editor-content fancy-scroll"
        style="max-width: 98vw; width: 1400px; max-height: 90vh; overflow: auto; padding: 24px; position: relative;">
        
        <!-- Header -->
        <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px;">
            <h3 style="margin: 0; color: #1976d2;">Add Parameter</h3>
            <button (click)="closeAddParameterDialog()"
                style="background: transparent; border: none; font-size: 24px; cursor: pointer; color: #888;"
                aria-label="Close dialog">
                &times;
            </button>
        </div>

        <!-- Search -->
        <div style="margin-bottom: 20px;">
            <div style="position: relative; width: 100%;">
                <span class="material-icons search-icon">
                    search
                </span>
                <input pInputText type="text" [(ngModel)]="addParamGlobalSearchValue"
                    (input)="onAddParamGlobalSearch($event)" placeholder="Search parameters..." maxlength="50"
                    class="beauty-search-input" />
            </div>
                <!-- Help message for range selection -->
            <div style="margin-top: 12px; padding: 8px 12px; background: #fff3cd; border-radius: 6px; border-left: 4px solid #ffc107;">
                <p style="margin: 0; font-size: 13px; color: #856404;">
                    <span class="material-icons" style="font-size: 16px; vertical-align: middle; margin-right: 4px;">info</span>
                    <strong>Range Selection:</strong> Use the checkboxes in the Range column to select which ranges you want to configure for each parameter. Only selected ranges will be added to your module configuration.
                </p>
            </div>
        </div>

        <!-- Parameters Table -->
        <div style="margin-bottom: 20px;">
            <!-- Show message when no parameters available -->
            <div *ngIf="!addParameterProducts || addParameterProducts.length === 0" 
                 style="text-align: center; padding: 40px; color: #666; background: #f5f5f5; border-radius: 6px;">
                <span class="material-icons" style="font-size: 48px; color: #ccc; margin-bottom: 16px; display: block;">info</span>
                <h4 style="margin: 0 0 8px 0; color: #333;">No Generic Parameters Available</h4>
                <p style="margin: 0; font-size: 14px;">No generic parameters found for this module. Please check the module configuration in the generic library.</p>
            </div>
            
            <!-- Show table only when parameters are available -->
            <p-table *ngIf="addParameterProducts && addParameterProducts.length > 0" 
                     #addParamTable
                     [value]="addParameterProducts" [dataKey]="'code'" [style]="{ width: '100%' }"
                     [tableStyle]="{ width: '100%' }" responsiveLayout="scroll"
                     [globalFilterFields]="['parameters', 'type', 'code', 'calculation']" [filterDelay]="0"
                     [scrollable]="true" scrollHeight="500px">
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 3rem"></th>
                        <th>Parameters</th>
                        <th>Unit</th>
                        <th>Type</th>
                        <th style="width: 50px;">Code</th>
                        <th>Upload Type</th>
                        <th>Weight</th>
                        <th>Formula</th>
                        <th>Calculation</th>
                        <th>Range</th>
                        <th>Score</th>
                        <th>Min</th>
                        <th>Max</th>
                        <th>Query</th>
                        <th>Critical Parameter</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                    <tr *ngFor="let range of product.ranges; let i = index">
                        <ng-container *ngIf="i === 0">
                            <td [attr.rowspan]="product.ranges.length" style="text-align: center;">
                                <input type="checkbox" [checked]="isParameterAlreadyConfigured(product) || hasAnyRangeSelected(product)" 
                                    [disabled]="isParameterAlreadyConfigured(product)"
                                    (change)="isParameterAlreadyConfigured(product) ? null : onAddParamToggleParameter(product)"
                                    [style.cursor]="isParameterAlreadyConfigured(product) ? 'not-allowed' : 'pointer'"
                                    [style.opacity]="isParameterAlreadyConfigured(product) ? 0.6 : 1"
                                    style="width: 22px; height: 22px; accent-color: #1976d2;" 
                                    [title]="isParameterAlreadyConfigured(product) ? 'This parameter is already configured' : (hasAnyRangeSelected(product) ? 'Click to deselect all ranges' : 'Click to select this parameter (auto-selects first range)')" />
                            </td>
                            <td [attr.rowspan]="product.ranges.length">{{product.parameters}}</td>
                            <td [attr.rowspan]="product.ranges.length">{{product.unit}}</td>
                            <td [attr.rowspan]="product.ranges.length">{{getTypeLabel(product.type)}}</td>
                            <td [attr.rowspan]="product.ranges.length" style="width: 50px;">{{product.code}}</td>
                            <td [attr.rowspan]="product.ranges.length">{{product.uploadType}}</td>
                            <td [attr.rowspan]="product.ranges.length">{{product.weight}}</td>
                            <td [attr.rowspan]="product.ranges.length" style="vertical-align: middle; text-align: center;">
                                <span style="display: inline-block; width: 100px;">{{product.formula}}</span>
                                <img src="../../../assets/images/icons8-formula-fx-50.png" alt="Edit formula"
                                    [style.cursor]="isParameterAlreadyConfigured(product) ? 'not-allowed' : 'pointer'"
                                    [style.opacity]="isParameterAlreadyConfigured(product) ? 0.4 : 1"
                                    style="width: 24px; height: 24px; margin-left: 8px; vertical-align: middle;"
                                    (click)="isParameterAlreadyConfigured(product) ? null : openAddParamFormulaEditor(product)" 
                                    [title]="isParameterAlreadyConfigured(product) ? 'Parameter already configured' : 'Edit formula'" />
                            </td>
                            <td [attr.rowspan]="product.ranges.length" style="vertical-align: middle; text-align: center;">
                                <div style="display: inline-flex; flex-direction: column; align-items: flex-start; gap: 4px;">
                                    <label style="display: flex; align-items: center; gap: 4px; cursor: pointer; line-height: 1;">
                                        <input type="checkbox"
                                            [checked]="product.calculation === 'DMS'"
                                            [disabled]="isParameterAlreadyConfigured(product)"
                                            (change)="isParameterAlreadyConfigured(product) ? null : toggleCalculationSelection(product, 'DMS')" />
                                        <span>DMS</span>
                                    </label>
                                    <label style="display: flex; align-items: center; gap: 4px; cursor: pointer; line-height: 1;">
                                        <input type="checkbox"
                                            [checked]="product.calculation === 'PUREBI'"
                                            [disabled]="isParameterAlreadyConfigured(product)"
                                            (change)="isParameterAlreadyConfigured(product) ? null : toggleCalculationSelection(product, 'PUREBI')" />
                                        <span>PUREBI</span>
                                    </label>
                                </div>
                            </td>
                        </ng-container>
                        <td>
                            <div class="range-controls">
                                <input type="checkbox" [checked]="range.selected" (change)="onAddParamRangeSelect(product, i)"
                                    [disabled]="isParameterAlreadyConfigured(product)"
                                    [style.cursor]="isParameterAlreadyConfigured(product) ? 'not-allowed' : 'pointer'"
                                    [style.opacity]="isParameterAlreadyConfigured(product) ? 0.6 : 1"
                                    style="width: 18px; height: 18px; accent-color: #1976d2; margin-right: 8px;" />
                                <span class="range-number">Range {{i + 1}}</span>
                            </div>
                        </td>
                        <td>
                            <input type="number" min="0" max="100" [(ngModel)]="range.score"
                                [disabled]="isParameterAlreadyConfigured(product)"
                                [style.opacity]="isParameterAlreadyConfigured(product) ? 0.6 : 1"
                                style="width:60px; text-align:center;" />
                        </td>
                        <td>
                            <input type="number" [(ngModel)]="range.min" style="width:60px; text-align:center;" 
                                [disabled]="isParameterAlreadyConfigured(product)"
                                (input)="validateRanges(product)"
                                [style.opacity]="isParameterAlreadyConfigured(product) ? 0.6 : 1"
                                [style.backgroundColor]="range.hasValidationError && range.selected ? '#ffebee' : ''"
                                [style.borderColor]="range.hasValidationError && range.selected ? '#f44336' : ''"
                                [style.borderWidth]="range.hasValidationError && range.selected ? '2px' : '1px'" />
                        </td>
                        <td>
                            <input type="number" [(ngModel)]="range.max" style="width:60px; text-align:center;" 
                                [disabled]="isParameterAlreadyConfigured(product)"
                                (input)="validateRanges(product)"
                                [style.opacity]="isParameterAlreadyConfigured(product) ? 0.6 : 1"
                                [style.backgroundColor]="range.hasValidationError && range.selected ? '#ffebee' : ''"
                                [style.borderColor]="range.hasValidationError && range.selected ? '#f44336' : ''"
                                [style.borderWidth]="range.hasValidationError && range.selected ? '2px' : '1px'" />
                        </td>
                        <td style="text-align: center;">
                            <div style="display: flex; align-items: center; justify-content: center; gap: 4px;">
                                <!-- <span style="max-width: 100px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                                    [title]="range.query">
                                    {{ range.query || '-' }}
                                </span> -->
                                <span class="material-icons" 
                                    [style.cursor]="(range.selected && !isParameterAlreadyConfigured(product)) ? 'pointer' : 'not-allowed'"
                                    [style.color]="(range.selected && !isParameterAlreadyConfigured(product)) ? '#1976d2' : '#ccc'"
                                    [style.opacity]="(range.selected && !isParameterAlreadyConfigured(product)) ? 1 : 0.4"
                                    [style.fontSize]="'20px'"
                                    (click)="(range.selected && !isParameterAlreadyConfigured(product)) ? openAddParamQueryEditor(range) : null" 
                                    [title]="isParameterAlreadyConfigured(product) ? 'Parameter already configured' : 'Edit query'">
                                    edit_note
                                </span>
                            </div>
                        </td>
                        <ng-container *ngIf="i === 0">
                            <td [attr.rowspan]="product.ranges.length" style="text-align: center;">
                                <mat-checkbox [(ngModel)]="product.criticalParameter" 
                                    [disabled]="isParameterAlreadyConfigured(product)"
                                    color="warn"></mat-checkbox>
                            </td>
                        </ng-container>
                    </tr>
                </ng-template>
            </p-table>
        </div>

        <!-- Action Buttons -->
        <div style="display: flex; justify-content: flex-end; gap: 12px; margin-top: 24px;">
            <button mat-stroked-button color="primary" (click)="closeAddParameterDialog()">
                Cancel
            </button>
            <button mat-flat-button color="accent" (click)="saveAddParameter()" 
                    [disabled]="!isAddParameterFormValid() || !addParameterProducts || addParameterProducts.length === 0">
                Save
            </button>
        </div>
    </div>
</div>

<!-- Formula Editor Dialog for Add Parameter Dialog -->
<div *ngIf="addParamFormulaEditorVisible" class="custom-editor-modal">
    <div class="custom-editor-backdrop" (click)="closeAddParamFormulaEditor()" style="z-index: 10000;"></div>
    <div class="custom-editor-content" style="z-index: 10001;">
        <h3>Edit Formula</h3>
        <textarea [(ngModel)]="addParamFormulaEditorText"
            [style]="{ width: '100%', height: '120px', fontSize: '15px', padding: '10px', borderRadius: '6px', border: '1px solid #ccc' }"
            placeholder="Enter formula here..."></textarea>
        <div style="text-align:right; margin-top:16px;">
            <button mat-stroked-button color="primary" (click)="closeAddParamFormulaEditor()" style="margin-right: 12px;">
                Cancel
            </button>
            <button mat-flat-button color="accent" (click)="saveAddParamFormulaEditor()">
                Save
            </button>
        </div>
    </div>
</div>

<!-- Query Editor Dialog for Add Parameter Dialog -->
<div *ngIf="addParamEditorVisible" class="custom-editor-modal">
    <div class="custom-editor-backdrop" (click)="closeAddParamEditor()" style="z-index: 10000;"></div>
    <div class="custom-editor-content" style="z-index: 10001;">
        <h3>Edit Query</h3>
        <textarea [(ngModel)]="addParamEditorText"
            [style]="{ width: '100%', height: '220px', fontSize: '15px', padding: '10px', borderRadius: '6px', border: '1px solid #ccc' }"
            placeholder="Enter query here..."></textarea>
        <div style="text-align:right; margin-top:16px;">
            <button mat-stroked-button color="primary" (click)="closeAddParamEditor()" style="margin-right: 12px;">
                Cancel
            </button>
            <button mat-flat-button color="accent" (click)="saveAddParamEditor()">
                Save
            </button>
        </div>
    </div>
</div>

<div *ngIf="formulaEditorDialogVisible" class="custom-editor-modal">
    <div class="custom-editor-backdrop" (click)="closeFormulaEditorDialog()"></div>
    <div class="custom-editor-content">
        <h3>Edit Formula</h3>
        <textarea [(ngModel)]="formulaEditorDialogText"
            [style]="{ width: '100%', height: '120px', fontSize: '15px', padding: '10px', borderRadius: '6px', border: '1px solid #ccc' }"
            placeholder="Enter formula here..."></textarea>
        <div style="text-align:right; margin-top:16px;">
            <button mat-stroked-button color="primary" (click)="closeFormulaEditorDialog()" style="margin-right: 12px;">
                Cancel
            </button>
            <button mat-flat-button color="accent" (click)="saveFormulaEditorDialog()">
                Save
            </button>
        </div>
    </div>
</div>
